export const SET_EVENTLIST = 'SET_EVENTLIST'
export const SET_SEARCH = 'SET_SEARCH'
export const SET_TOTAL = 'SET_TOTAL'
export const SET_DATE_RANGE = 'SET_DATE_RANGE'
export const SET_CLEAR_ALL = 'SET_CLEAR_ALL'
export const SET_CLEAR_SEARCH = 'SET_CLEAR_SEARCH'
export const SET_LOADING = 'SET_LOADING'
export const SET_PAGE = 'SET_PAGE'
export const SET_MONTH_EVENTS = 'SET_MONTH_EVENTS'
export const SET_CATEGORY_LIST = 'SET_CATEGORY_LIST'
export const SET_FILTER = 'SET_FILTER'
export const SET_SELECTED_CATEGORIES = 'SET_SELECTED_CATEGORIES';
export const SET_SELECTED_MONTH = 'SET_SELECTED_MONTH';
export const SET_MONTH_VIEW = 'SET_MONTH_VIEW';
export const SET_DATE_MANUALLY_SELECTED = 'SET_DATE_MANUALLY_SELECTED';
export const SET_NAVIGATION_DIRECTION = "SET_NAVIGATION_DIRECTION";
